export const AriaLabel = {
  clickExpand: 'click-expand',
  clickClose: 'click-close',
} as const;

export type AriaLabel = typeof AriaLabel[keyof typeof AriaLabel];
